<template>
  <div id="Urzadzenia">

    <!-- <h4>{{ $t("message.devices") }}
      <button style="float: right; background: none; border: none; color: white; cursor: pointer;" @click="clear_clusters()">
        <img src="../assets/icon_clear.svg" class="imgClear" style="width: 21px" title="wyczyść ustawienia"/>
      </button>
    </h4> -->
    <div>
      <div id="nav">
        <button :class="{ 'active' : (page==='cluster1')}" id="tab-cluster1" md-label="Cluster 1" @click="changePage('cluster1')">{{ $t("message.cluster") }} 1</button>
        <button :class="{ 'active' : (page==='cluster2'), 'disabled': disabled2}" id="tab-cluster2" md-label="Cluster 2" @click="changePage('cluster2')" :disabled='disabled2'>{{ $t("message.cluster") }} 2</button>
        <button :class="{ 'active' : (page==='cluster3'), 'disabled': disabled3}" id="tab-cluster3" md-label="Cluster 3" @click="changePage('cluster3')" :disabled='disabled3'>{{ $t("message.cluster") }} 3</button>
        <button :class="{ 'active' : (page==='cluster4'), 'disabled': disabled4}" id="tab-cluster4" md-label="Cluster 4" @click="changePage('cluster4')" :disabled='disabled4'>{{ $t("message.cluster") }} 4</button>
        <button :class="{ 'active' : (page==='cluster5'), 'disabled': disabled5}" id="tab-cluster5" md-label="Cluster 5" @click="changePage('cluster5')" :disabled='disabled5'>{{ $t("message.cluster") }} 5</button>
        <button :class="{ 'active' : (page==='cluster6'), 'disabled': disabled6}" id="tab-cluster6" md-label="Cluster 6" @click="changePage('cluster6')" :disabled='disabled6'>{{ $t("message.cluster") }} 6</button>
      </div>
    </div>
    <div class="tab-content" v-show="page === 'cluster1'">
      <Cluster1 :clear='(cls === 1) ? true: false' :prefix='"c1"'/>
    </div>
    <div class="tab-content" v-show="page === 'cluster2'">
      <Cluster2 :clear='(cls === 2) ? true: false' :prefix='"c2"'/>
    </div>
    <div class="tab-content" v-show="page === 'cluster3'">
      <Cluster3 :clear='(cls === 3) ? true: false' :prefix='"c3"'/>
    </div>
    <div class="tab-content" v-show="page === 'cluster4'">
      <Cluster4 :clear='(cls === 4) ? true: false' :prefix='"c4"'/>
    </div>
    <div class="tab-content" v-show="page === 'cluster5'">
      <Cluster5 :clear='(cls === 5) ? true: false' :prefix='"c5"'/>
    </div>
    <div class="tab-content" v-show="page === 'cluster6'">
      <Cluster6 :clear='(cls === 6) ? true: false' :prefix='"c6"'/>
    </div>
  <div v-if="page === 'cluster'+checkLast" style="position: absolute;right: 0px;bottom: 8px;">
    <button class="btn btn-danger" style="float: right;padding: 1px 9px;background: #fb7e7e none repeat scroll 0% 0%;" @click="clearCluster(checkLast)">
      <img src="../assets/icon_clear_white.png" style="width:24px; margin-right:10px" :title="$t('message.clearCluster')"/>{{ $t("message.cluster") }}</button>
  </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

import Cluster1 from './Clusters/Cluster1'
import Cluster2 from './Clusters/Cluster2'
import Cluster3 from './Clusters/Cluster3'
import Cluster4 from './Clusters/Cluster4'
import Cluster5 from './Clusters/Cluster5'
import Cluster6 from './Clusters/Cluster6'

export default {
  name: 'Urzadzenia',
  mixins: [app, materials, calculation],
  components: {Cluster1, Cluster2, Cluster3, Cluster4, Cluster5, Cluster6},
  data () {
    return {
      page: 'cluster1',
      cls: 0
    }
  },
  watch: {
    clearing (newValue) {
      if (newValue === true) {
        this.page = 'cluster1'
      }
    }
  },
  computed: {
    ...mapGetters('app', ['clusters', 'clearing']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['openFile']),
    ...mapGetters('app', ['copyValues']),
    ...mapGetters('app', ['clusterOne']),
    ...mapGetters('app', ['clusterTwo']),
    ...mapGetters('app', ['clusterThree']),
    ...mapGetters('app', ['clusterFour']),
    ...mapGetters('app', ['clusterFive']),
    ...mapGetters('app', ['clusterSix']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaBosch']),
    ...mapGetters('products', ['ListaPulsar']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaMaterialy']),
    disabled2 () {
      return !((this.clusters.cluster1 && Object.keys(this.clusters.cluster1).length > 0))
    },
    disabled3 () {
      return !((this.clusters.cluster2 && Object.keys(this.clusters.cluster2).length > 0))
    },
    disabled4 () {
      return !((this.clusters.cluster3 && Object.keys(this.clusters.cluster3).length > 0))
    },
    disabled5 () {
      return !((this.clusters.cluster4 && Object.keys(this.clusters.cluster4).length > 0))
    },
    disabled6 () {
      return !((this.clusters.cluster5 && Object.keys(this.clusters.cluster5).length > 0))
    },
    checkLast () {
      var index = 0
      for (var aa in this.clusters) {
        if (Object.keys(this.clusters[aa]).length) {
          index++
        }
      }
      return index
    }
  },
  methods: {
    changePage (page) {
      this.page = page
    },
    clearCluster (index) {
      this.cls = index
      this.$store.commit('app/CLEAR_CLUSTER', index)
      // console.log('clearCluster')
      this.obliczenia_sprzetowe()

      setTimeout(() => {
        // this.postRecordSolo('clientStore/UPDATE_RECORDS_NO_TAB', this.endPoint, true)
        this.cls = 0
      }, 1000)
    }
  }
}
</script>

<style scoped>
  .wariant-label {
    width:74px;
  }
  .wariant-input {
    /* position: relative;
    left: -48px;
    top: 4px;*/
    width:60px
  }
  .wariant-rozszerzenia-input {
    /* position: relative;
    right: 2px;
    top: 4px; */
    width: 60px;
  }
  .wariant-span {
    font-size: 13px;
    margin: 0px 12px;
  }

  #nav {
    border-bottom: 1px solid #999
  }
  #nav button#tab-cluster1, #nav button#tab-cluster2, #nav button#tab-cluster3, #nav button#tab-cluster4, #nav button#tab-cluster5, #nav button#tab-cluster6 {
    background: #fff;
    width: 90px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #999;
    top: 1px;
    position: relative;
    cursor: pointer;
    height: 35px;
    border-radius: 10px 10px 0px 0px;
    color: #aaa;
  }
  #nav button#tab-cluster1.active, #nav button#tab-cluster2.active, #nav button#tab-cluster3.active, #nav button#tab-cluster4.active, #nav button#tab-cluster5.active, #nav button#tab-cluster6.active {
    border-top: 1px solid #999;
    border-left: 1px solid #999;
    border-right: 1px solid #999;
    border-bottom: 1px solid #fff;
    /* color: #1192df; */
    color: #333;
    font-weight: bold;
  }
  #tab-main, #tab-other {
    margin-top: 5px;
  }
  .md-avatar {
    width: 0px;
    min-width: 20px;
    height: 28px;
    border-radius: 0px;
    margin:2px 0px;
  }
  .tooltipImg  {
    margin-left:50px;
    padding:10px;
    width: 520px;
    height: 400px;
    font-size: 14px;
    background: white !important;
    border: 3px solid #215D8C !important;
  }
  .tooltipImg img {
    padding: 10px;
    font-size: 14px;
  }
  .tooltipImg h4 {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .tooltipImg p {
    color: #333;
    font-size: 16px;
    text-align: left;
  }
  .tab-content {
    margin-top:10px
  }
  .disabled {
    border-top: 1px solid #eee !important;
    border-left: 1px solid #eee !important;
    border-right: 1px solid #eee !important;
    border-bottom: 1px solid #999;
    color: #eee !important;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Urzadzenia.vue